import React, { useEffect, useState, useContext } from 'react'
import FontContext from '../../context/fontsize/fontContext'
import AppBar from '@material-ui/core/AppBar'
import CssBaseline from '@material-ui/core/CssBaseline'
import Divider from '@material-ui/core/Divider'
import Drawer from '@material-ui/core/Drawer'
import Hidden from '@material-ui/core/Hidden'
import IconButton from '@material-ui/core/IconButton'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemText from '@material-ui/core/ListItemText'
import MenuIcon from '@material-ui/icons/Menu'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { makeStyles, useTheme } from '@material-ui/core/styles'
import { BsSun, BsMoon } from 'react-icons/bs'
import Grid from '@material-ui/core/Grid'
import Fade from '@material-ui/core/Fade'
import Tooltip from '@material-ui/core/Tooltip'
import { OutboundLink } from 'gatsby-plugin-google-gtag'

import Navlinks from '../../constants/navLinks'
// import FeaturedPosts from '../../constants/dummyPosts'
import fb from '../../assets/images/fb.svg'
import twit from '../../assets/images/twit.svg'
import ig from '../../assets/images/ig.svg'

import { graphql, useStaticQuery, Link } from 'gatsby'
import slugify from 'slugify'
const query = graphql`
	{
		allContentfulBlogPost(
			filter: { featured: { eq: true } }
			sort: { fields: createdAt, order: DESC }
			limit: 3
		) {
			nodes {
				shortTitle
				title
				id
				createdAt(formatString: "MM/DD/YYYY")
			}
		}
		site {
			siteMetadata {
				title
			}
		}
	}
`

const drawerWidth = 220

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	drawer: {
		[theme.breakpoints.only('sm')]: {
			width: 175,
			flexShrink: 0,
		},
		[theme.breakpoints.up('md')]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	appBar: {
		[theme.breakpoints.up('sm')]: {
			display: 'none',
			// width: `calc(100% - ${drawerWidth}px)`,
			// marginLeft: drawerWidth,
		},
	},
	menuButton: {
		marginRight: theme.spacing(2),
		color: theme.palette.common.accent,
		[theme.breakpoints.up('sm')]: {
			display: 'none',
		},
	},
	// necessary for content to be below app bar
	toolbar: theme.mixins.toolbar,
	drawerPaper: {
		width: drawerWidth,
		borderRight: `1px solid ${theme.palette.common.accent}`,
		WebkitBoxShadow: `4px 0px 4px 0px rgba(0,0,0,0.39)`,
		boxShadow: `4px 0px 4px 0px rgba(0,0,0,0.39)`,
		[theme.breakpoints.only('sm')]: {
			width: 200,
			flexShrink: 0,
		},
		[theme.breakpoints.up('md')]: {
			width: drawerWidth,
			flexShrink: 0,
		},
	},
	content: {
		flexGrow: 1,
		// padding: theme.spacing(3),
		backgroundColor: theme.palette.background.default,
	},
	navlink: {
		color: theme.palette.common.accent,
		marginLeft: '2.5em',
		textTransform: 'uppercase',
		paddingTop: '.5em',
		'& span': {
			fontSize: '.8rem',
		},
	},
	navlinkLight: {
		color: theme.palette.common.accent,
		marginLeft: '2.5em',
		textTransform: 'uppercase',
		paddingTop: '.5em',
		'& span': {
			fontSize: '.9rem',
			fontWeight: 500,
			textShadow: 'rgba(0,0,0, 0.1) 0px 0px 20px',
		},
	},
	sitetitle: {
		// marginTop: '-1em',
		marginTop: '.5em',
		color: theme.palette.common.accent,
		textTransform: 'uppercase',
		fontWeight: 500,
		marginLeft: '2em',
	},
	btn: {
		// '&:hover': {
		// 	backgroundColor: theme.palette.common.accent,
		// 	opacity: 0.3,
		// },
	},
	child: {
		backgroundColor: theme.palette.common.accent,
	},
	rippleVisible: {
		opacity: 0.5,
		animation: `$enter 550ms ${theme.transitions.easing.easeInOut}`,
	},
	'@keyframes enter': {
		'0%': {
			transform: 'scale(0)',
			opacity: 0.1,
		},
		'100%': {
			transform: 'scale(1)',
			opacity: 0.5,
		},
	},
	active: {
		backgroundColor: theme.palette.common.accent,
	},
	hr: {
		backgroundColor: theme.palette.common.accent,
		opacity: 0.1,
	},
	ftNumber: {
		boxShadow: `inset 2px 0px 0px 0px solid ${theme.palette.common.accent}`,
		color: theme.palette.common.accent,
	},
	ftTitle: {
		color: theme.palette.common.accent,
		fontSize: '.8rem',
		[theme.breakpoints.up('md')]: {
			marginLeft: '5px',
		},
		[theme.breakpoints.down('sm')]: {
			paddingRight: 5,
		},
	},
	underline: {
		width: '10%',
		borderBottom: `2px solid ${theme.palette.common.darker}`,
		opacity: 1,
		position: 'absolute',
		top: '-2em',
		bottom: 10,
		left: '1.20em',
	},
	socialLinks: {
		height: 'calc(100% - 40px)',
		paddingBottom: '1.5em',
	},
}))

export default function ResponsiveDrawer({
	children,
	title,
	fbURL,
	igURL,
	twitURL,
}) {
	const {
		allContentfulBlogPost: { nodes: featuredPosts },
		site: { siteMetadata: meta },
	} = useStaticQuery(query)
	const { win } = children
	const classes = useStyles()
	const theme = useTheme()
	const [mobileOpen, setMobileOpen] = React.useState(false)
	const [displayFeatured, setDisplayFeatured] = useState(false)
	const fontContext = useContext(FontContext)
	const { darkMode, setDarkMode } = fontContext

	const handleDrawerToggle = () => {
		setMobileOpen(!mobileOpen)
	}

	useEffect(() => {
		const path = window.location.pathname
		if (path === '/') {
			setDisplayFeatured(false)
		} else {
			setDisplayFeatured(true)
		}
	}, [])

	const handleThemeChange = () => {
		if (darkMode) {
			localStorage.setItem('preferred-theme', 'light')
			setDarkMode(false)
		} else {
			localStorage.setItem('preferred-theme', 'dark')
			setDarkMode(true)
		}
	}

	const drawer = (
		<>
			<div className={classes.toolbar} />
			<Grid container>
				<Grid item xs={9}>
					<Link to='/' style={{ textDecoration: 'none' }}>
						<Typography variant='h6' className={classes.sitetitle}>
							{title}
						</Typography>
					</Link>
				</Grid>
				<Grid item xs={3}>
					<Tooltip
						disableFocusListener
						disableTouchListener
						title='Toggle dark/light mode'
					>
						<IconButton onClick={handleThemeChange} style={{ zIndex: 1402 }}>
							{darkMode ? (
								<Fade in={darkMode}>
									<BsSun
										size={20}
										style={{ color: theme.palette.common.accent }}
									/>
								</Fade>
							) : (
								<Fade in={!darkMode}>
									<BsMoon
										size={20}
										style={{ color: theme.palette.common.accent }}
									/>
								</Fade>
							)}
						</IconButton>
					</Tooltip>
				</Grid>
			</Grid>
			<Divider className={classes.hr} />
			<List>
				{Navlinks.map((route) => (
					<ListItem
						button
						className={classes.btn}
						key={route.id}
						disableGutters
					>
						<Link
							to={route.url}
							activeStyle={{
								borderLeft: `6px solid ${theme.palette.common.accent}`,
								marginLeft: '0px',
							}}
							style={{
								height: '100%',
								width: '100%',
								marginLeft: '6px',
								textDecoration: 'none',
							}}
						>
							<ListItemText
								primary={route.text}
								className={darkMode ? classes.navlink : classes.navlinkLight}
							/>
						</Link>
					</ListItem>
				))}
			</List>
			<Divider className={classes.hr} />
			<Fade in={displayFeatured} timeout={1000}>
				<Grid container style={{ paddingTop: '.75em' }}>
					<Typography
						variant='h6'
						style={{
							color: theme.palette.common.accent,
							textTransform: 'uppercase',
							marginLeft: '1em',
							// paddingTop: '.1em',
						}}
					>
						Featured
					</Typography>
					<List>
						{featuredPosts.map((post, i) => {
							const slug = slugify(post.title, { lower: true })
							return (
								<Link
									to={`/articles/${slug}`}
									key={post.id}
									style={{ textDecoration: 'none' }}
								>
									<ListItem
										button
										className={classes.btn}
										// key={post.id}
										disableGutters
									>
										<Grid item xs={3} sm={3} md={3}>
											<Typography
												variant='h5'
												align='center'
												className={classes.ftNumber}
											>
												{i + 1}
											</Typography>
											<div className={classes.underline} />
										</Grid>
										<Grid item xs={9} sm={9} md={9}>
											<Typography variant='body2' className={classes.ftTitle}>
												{post.shortTitle}
											</Typography>
										</Grid>
									</ListItem>
								</Link>
							)
						})}
					</List>
				</Grid>
			</Fade>
			<Grid
				container
				alignItems='flex-end'
				justify='space-around'
				className={classes.socialLinks}
				spacing={0}
			>
				<Grid item>
					<a href={igURL} target='_blank' rel='noreferrer'>
						<IconButton>
							<img src={ig} alt='instagram' />
						</IconButton>
					</a>
				</Grid>
				<Grid item>
					<a href={twitURL} target='_blank' rel='noreferrer'>
						<IconButton>
							<img src={twit} alt='twitter' />
						</IconButton>
					</a>
				</Grid>
				<Grid item>
					<a href={fbURL} target='_blank' rel='noreferrer'>
						<IconButton>
							<img src={fb} alt='facebook' />
						</IconButton>
					</a>
				</Grid>
				<OutboundLink
					href='https://snappywebdesign.net/'
					style={{
						zIndex: 1403,

						textDecoration: 'none',
						color: darkMode ? '#4ecca3' : '#717171',
						marginLeft: 'auto',
						marginRight: 'auto',
						fontSize: '.8rem',
					}}
				>
					Powered by Snappy Web Design
				</OutboundLink>
			</Grid>
		</>
	)

	const container = win !== undefined ? () => window().document.body : undefined

	return (
		<div className={classes.root}>
			<CssBaseline />
			<AppBar position='fixed' className={classes.appBar}>
				<Toolbar>
					<IconButton
						color='inherit'
						aria-label='open drawer'
						edge='start'
						onClick={handleDrawerToggle}
						className={classes.menuButton}
					>
						<MenuIcon />
					</IconButton>
					<Typography
						variant='h6'
						noWrap
						style={{ color: theme.palette.common.accent }}
					>
						{meta.title}
					</Typography>
				</Toolbar>
			</AppBar>
			<nav className={classes.drawer} aria-label='mailbox folders'>
				{/* The implementation can be swapped with js to avoid SEO duplication of links. */}
				<Hidden smUp implementation='css'>
					<Drawer
						container={container}
						variant='temporary'
						anchor={theme.direction === 'rtl' ? 'right' : 'left'}
						open={mobileOpen}
						onClose={handleDrawerToggle}
						classes={{
							paper: classes.drawerPaper,
						}}
						ModalProps={{
							keepMounted: true, // Better open performance on mobile.
						}}
					>
						{drawer}
					</Drawer>
				</Hidden>
				<Hidden xsDown implementation='css'>
					<Drawer
						classes={{
							paper: classes.drawerPaper,
						}}
						variant='permanent'
						open
					>
						{drawer}
					</Drawer>
				</Hidden>
			</nav>
			<main className={classes.content}>
				<div className={classes.toolbar} />
				{children}
			</main>
		</div>
	)
}
